import Component from 'flarum/common/Component';

export default class StatisticBasicComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const {infoStatistic} = this.attrs;
    this.mapTotalItemCount = infoStatistic.mapTotalItemCount;
    this.mapTotalAreaCount = infoStatistic.mapTotalAreaCount;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    return (
      <div className="u2diStatisticContainer">
        <div>
          <span className="u2diStatisticValue">{Math.round(this.mapTotalAreaCount)}</span>
          <span className="u2diStatisticUnit">{app.translator.trans('ziven-u2di.lib.unit-mu')}</span>
        </div>
      </div>
    );
  }

}